/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Polish
export default {
    'fabric.atlassianSwitcher.switchTo': 'Przełącz na',
    'fabric.atlassianSwitcher.switchToTooltip': 'Przełącz na…',
    'fabric.atlassianSwitcher.recent': 'Ostatnie',
    'fabric.atlassianSwitcher.more': 'Więcej',
    'fabric.atlassianSwitcher.try': 'Wypróbuj',
    'fabric.atlassianSwitcher.manageList': 'Zarządzaj listą',
    'fabric.atlassianSwitcher.jiraProject': 'Projekt Jira',
    'fabric.atlassianSwitcher.confluenceSpace': 'Przestrzeń Confluence',
    'fabric.atlassianSwitcher.people': 'Użytkownicy',
    'fabric.atlassianSwitcher.administration': 'Administracja',
    'fabric.atlassianSwitcher.discoverMore': 'Odkryj więcej',
    'fabric.atlassianSwitcher.errorHeading': 'Wystąpił błąd',
    'fabric.atlassianSwitcher.errorText': 'Monitorujemy te błędy, ale nie wahaj się skontaktować z nami, jeśli odświeżanie nie rozwiąże problemów',
    'fabric.atlassianSwitcher.errorImageAltText': 'Zepsuty robot i wiele osób pracuje, aby usunąć błąd.',
    'fabric.atlassianSwitcher.expand': 'Rozwiń',
};
//# sourceMappingURL=pl.js.map